import { TOOL } from '@/api/apiModules'
import lang from '@/lang'
import dictionary from '@/utils/dictionary'
export default {
  viewType: 'detail',
  view: {
    tabs: [
      {
        label: 'baseInfo',
        viewMetaData: {
          module: TOOL,
          params: null,
          fillDetailUrl: `${TOOL}/detail`,
          viewType: 'form',
          cb() {},
          view: {
            isSimple: false,
            labelWidth: '140px',
            header: {},
            content: [
              {
                isGroup: true,
                $type: 'group',
                $id: 'base',
                title: 'overview',
                icon: 'sk-icon-overview',
                $items: [
                  {
                    $id: 'toolLogoBase64',
                    label: '工具Logo',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.toolLogoBase64) {
                        return
                      }
                      return <img src={`${data.toolLogoBase64}`} style={{ width: '58px', height: '58px' }} />
                    }
                  },
                  {
                    $id: 'toolName',
                    label: '程序名称'
                  },
                  {
                    $id: 'toolDesc',
                    label: '工具名称'
                  },
                  {
                    $id: 'toolVersion',
                    label: '工具版本'
                  },
                  {
                    $id: 'toolDetail',
                    label: '工具用途'
                  },
                  {
                    $id: 'toolScene',
                    label: '使用场景'
                  },
                  {
                    $id: 'provideMode',
                    label: '工具下载方式',
                    dataType: 'enum'
                  },
                  {
                    $id: 'toolUrl',
                    label: '下载地址'
                  },
                  {
                    $id: 'toolGuide',
                    label: '使用指南'
                  },
                  {
                    $id: 'toolFaq',
                    label: '常见问题'
                  },
                  {
                    $id: 'toolChecksum',
                    label: '文件摘要(MD5)'
                  },
                  {
                    $id: 'toolSource',
                    label: '工具来源',
                    dataType: 'enum'
                  },
                  {
                    $id: 'toolProvider',
                    label: '工具提供者'
                  },
                  {
                    $id: 'toolCategory',
                    label: '工具分类',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.toolCategory) {
                        return
                      }
                      const renderItem = []

                      data.toolCategory.split(',').forEach(el => {
                        renderItem.push(
                          <div class="wsp-padding-tb-3">
                            <el-tag type={dictionary['toolCategory'][el].type}>
                              {lang.t(dictionary['toolCategory'][el].label)}
                            </el-tag>
                          </div>
                        )
                      })
                      return renderItem
                    }
                  },
                  {
                    $id: 'toolSyncTime',
                    label: '同步时间',
                    dataType: 'date'
                  },
                  {
                    $id: 'toolSyncUid',
                    label: '源系统工具UID'
                  },
                  {
                    $id: 'toolStatus',
                    label: '状态',
                    dataType: 'enum'
                  },
                  {
                    $id: 'toolDeployRange',
                    label: '发布范围',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.toolDeployRange) {
                        return
                      }
                      const renderItem = []

                      data.toolDeployRange.split(',').forEach(el => {
                        renderItem.push(
                          <div class="wsp-padding-tb-3">
                            <el-tag type={dictionary['toolDeployRange'][el].type}>
                              {lang.t(dictionary['toolDeployRange'][el].label)}
                            </el-tag>
                          </div>
                        )
                      })
                      return renderItem
                    }
                  },
                  {
                    $id: 'createTime',
                    label: '创建时间',
                    dataType: 'date'
                  },
                  {
                    $id: 'realName',
                    label: '创建人'
                  }
                ]
              }
            ]
          }
        }
      }
    ]
  }
}
